/* Pet Love Arcade mini-engine (Fetch Frenzy, Doggy Dash, Treat Tower). Shared: canvas scaling, start/how-to/game-over overlays,
   best score, sound, input (touch, mouse, keyboard), share, "Wear your high score" card. */
(function(){
  if (window.HTPG) return;
  var lastTouch = 0; /* shared so the click after a touch never double-fires on re-rendered elements */
  function onTap(el, fn){
    el.addEventListener('pointerup', function(e){ if (e.pointerType === 'mouse') return; lastTouch = Date.now(); fn(e); });
    el.addEventListener('click', function(e){ if (Date.now() - lastTouch < 700) return; fn(e); });
  }
  var AC = null;
  function beep(on, f, d, type, vol){
    if (!on) return;
    try {
      AC = AC || new (window.AudioContext || window.webkitAudioContext)();
      if (AC.state === 'suspended') AC.resume();
      var o = AC.createOscillator(), g = AC.createGain(), t = AC.currentTime;
      o.type = type || 'square'; o.frequency.setValueAtTime(f, t);
      g.gain.setValueAtTime(vol || 0.05, t); g.gain.exponentialRampToValueAtTime(0.0001, t + (d || 0.12));
      o.connect(g); g.connect(AC.destination); o.start(t); o.stop(t + (d || 0.12) + 0.02);
    } catch(e){}
  }
  function lsGet(k, d){ try { var v = localStorage.getItem(k); return v === null ? d : v; } catch(e){ return d; } }
  function lsSet(k, v){ try { localStorage.setItem(k, v); } catch(e){} }

  function create(root, G){
    var q = function(s){ return root.querySelector(s); };
    var cv = q('[data-pg-canvas]'), ctx = cv.getContext('2d');
    var W = G.w, H = G.h, dpr = 1;
    var scoreEl = q('[data-pg-score]'), bestEl = q('[data-pg-best]'), extraEl = q('[data-pg-extra]');
    var startOv = q('[data-pg-start]'), overOv = q('[data-pg-over]'), howOv = q('[data-pg-how]');
    var soundBtn = q('[data-pg-sound]');
    var bestKey = 'htpg-best-' + G.id, seenKey = 'htpg-seen-' + G.id;
    var S = { state: 'idle', score: 0, best: +lsGet(bestKey, 0) || 0, t: 0, sound: lsGet('htpg-sound', '1') === '1', W: W, H: H };
    S.sfx = function(f, d, type, vol){ beep(S.sound, f, d, type, vol); };
    if (window.PLW) PLW.attach(cv, { w: G.w, h: G.h, mode: G.wide ? 'extend' : 'center', fixH: !!(G.wide && G.wide.fixH), maxW: G.wide && G.wide.maxW, maxH: G.wide && G.wide.maxH, onResize: function(w, h){ W = w; H = h; S.W = w; S.H = h; if (G.resize) G.resize(S); }, redraw: function(){ if (S.state !== 'play') G.draw(ctx, S); } });
    function fit(){
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (S.state !== 'play') G.draw(ctx, S);
    }
    function hud(){
      scoreEl.textContent = S.score; bestEl.textContent = S.best;
      if (extraEl && G.extra) extraEl.textContent = G.extra(S);
    }
    function show(ov, on){ if (ov) ov.hidden = !on; }
    function start(){
      AC && AC.state === 'suspended' && AC.resume();
      S.score = 0; S.t = 0; S.state = 'play';
      G.init(S); hud();
      show(startOv, false); show(overOv, false); show(howOv, false);
      last = performance.now(); S.sfx(660, 0.08); S.sfx(880, 0.1);
      root.setAttribute('data-pg-state', 'play');
    }
    S.add = function(n){ S.score += n; hud(); };
    S.hud = hud;
    S.over = function(title, sub){
      if (S.state !== 'play') return;
      S.state = 'over'; root.setAttribute('data-pg-state', 'over');
      var nb = S.score > S.best;
      if (nb){ S.best = S.score; lsSet(bestKey, S.best); }
      hud();
      q('[data-pg-over-title]').textContent = title || 'Game over!';
      q('[data-pg-over-sub]').textContent = (sub ? sub + ' ' : '') + 'Score: ' + S.score + '.';
      q('[data-pg-over-best]').textContent = nb && S.score > 0 ? 'New best score!' : 'Best: ' + S.best;
      S.sfx(330, 0.18, 'sawtooth'); setTimeout(function(){ S.sfx(220, 0.25, 'sawtooth'); }, 150);
      setTimeout(function(){ show(overOv, true); var b = q('[data-pg-again]'); b && b.focus({ preventScroll: true }); }, 450);
      try { document.dispatchEvent(new CustomEvent('ht:gameover', { detail: { game: G.id, score: S.score } })); } catch(e){}
    };
    var last = 0;
    function loop(now){
      requestAnimationFrame(loop);
      if (S.state !== 'play'){ return; }
      var dt = Math.min(0.033, (now - last) / 1000); last = now;
      if (document.hidden) return;
      S.t += dt; G.update(dt, S); G.draw(ctx, S);
    }
    function pt(e){
      var r = cv.getBoundingClientRect();
      return { x: (e.clientX - r.left) / r.width * W, y: (e.clientY - r.top) / r.height * H };
    }
    cv.addEventListener('pointerdown', function(e){
      if (S.state !== 'play') return;
      e.preventDefault();
      var p = pt(e); G.tap && G.tap(p.x, p.y, S);
    });
    cv.addEventListener('pointermove', function(e){ if (S.state === 'play' && G.move){ var p = pt(e); G.move(p.x, p.y, S); } });
    cv.addEventListener('pointerup', function(e){ if (S.state === 'play' && G.release){ var p = pt(e); G.release(p.x, p.y, S); } });
    root.addEventListener('keydown', function(e){
      var k = e.key;
      if ((k === ' ' || k === 'Enter') && S.state !== 'play' && (e.target === cv || e.target === root)){ e.preventDefault(); start(); return; }
      if (S.state === 'play' && G.key){ if (G.key(k, S) !== false && /^(Arrow|\s)/.test(k === ' ' ? ' ' : k)) e.preventDefault(); }
    });
    root.addEventListener('keyup', function(e){ if (S.state === 'play' && G.keyup) G.keyup(e.key, S); });
    root.querySelectorAll('[data-pg-go]').forEach(function(b){ onTap(b, function(){ lsSet(seenKey, '1'); start(); cv.focus({ preventScroll: true }); }); });
    root.querySelectorAll('[data-pg-again],[data-pg-restart]').forEach(function(b){ onTap(b, function(){ start(); cv.focus({ preventScroll: true }); }); });
    root.querySelectorAll('[data-pg-howbtn]').forEach(function(b){ onTap(b, function(){ if (S.state === 'play') S.state = 'paused'; show(howOv, true); }); });
    root.querySelectorAll('[data-pg-share]').forEach(function(b){ onTap(b, function(){
      var txt = 'I scored ' + S.score + ' in ' + G.title + ' on Pet Love Arcade! Can you beat me?';
      var url = location.origin + location.pathname;
      if (navigator.share){ navigator.share({ title: G.title, text: txt, url: url }).catch(function(){}); }
      else if (navigator.clipboard){ navigator.clipboard.writeText(txt + ' ' + url).then(function(){ b.textContent = 'Copied!'; setTimeout(function(){ b.textContent = 'Share score'; }, 1500); }).catch(function(){ window.prompt('Copy your score to share:', txt + ' ' + url); }); }
    }); });
    function setSound(){ soundBtn.textContent = S.sound ? 'Sound on' : 'Sound off'; soundBtn.setAttribute('aria-pressed', S.sound ? 'true' : 'false'); }
    if (soundBtn){ setSound(); onTap(soundBtn, function(){ S.sound = !S.sound; lsSet('htpg-sound', S.sound ? '1' : '0'); setSound(); }); }
    window.addEventListener('resize', fit);
    G.init(S); fit(); hud();
    if (!lsGet(seenKey, '') && howOv){ show(startOv, false); show(howOv, true); }
    requestAnimationFrame(function(n){ last = n; loop(n); });
    root.__S = S;
    return S;
  }
  window.HTPG = { create: create, onTap: onTap };
})();
